import React from 'react';
import classNames from 'classnames';
import Image from 'next/image';

import { ArrRight } from '@/icons/index';

import SectionTitle from '../SectionTitle/SectionTitle';
import TextBlock from '../TextBlock/TextBlock';
import Tabs from '../Tabs/Tabs';
import TabPanel from '../Tabs/TabPanel';
import Tab from '../Tabs/Tab';
import TabContent from '../Tabs/TabContent';
import TabContentItem from '../Tabs/TabContentItem';
import SliderWrapper from '../SliderWrapper/SliderWrapper';

import styles from './DocumentCard.module.scss';

const CardBlock = ({ data, className }) => {
  const [activeTab, setActiveTab] = React.useState(0);
  const renderButtonsList = (item, index) => {
    return (
      <a
        title={item?.text}
        aria-label={item?.text}
        href={item?.file}
        download
        key={index}
        className={styles.button}
        itemScope
        itemType='https://schema.org/ImageGallery'
      >
        <span className={styles.documentIcon}>
          <Image
            src={item?.icon}
            width={24}
            height={24}
            alt={item.text}
            title={item.text}
            loading='lazy'
          />
        </span>
        {item.text}
        <span className={styles.arrowIcon}>
          <ArrRight width={24} />
        </span>
      </a>
    );
  };

  const renderCardItem = (item, index) => {
    return (
      <article
        className={styles['document-card']}
        key={index}
        itemScope
        itemType='https://schema.org/ListItem'
      >
        <div className={styles['document-card__content']}>
          {item?.year && (
            <SectionTitle
              titleModify={classNames(
                styles['document-card__year'],
                'title--medium',
              )}
            >
              {item.year}
            </SectionTitle>
          )}
          {item?.title && (
            <TextBlock
              className={classNames(
                styles['document-card__desc'],
                'text--large',
              )}
            >
              {item.title}
            </TextBlock>
          )}
        </div>
        {item?.buttons?.length && (
          <div className={styles['document-card__buttons']}>
            {item?.buttons.map(renderButtonsList)}
          </div>
        )}
      </article>
    );
  };

  const renderTab = (item, index) => {
    return (
      <Tab
        key={index}
        onClick={() => setActiveTab(index)}
        itemScope
        itemType='https://schema.org/Text'
      >
        {item.title}
      </Tab>
    );
  };

  const renderContent = (item, index) => {
    return (
      <TabContentItem key={index} className={styles.tabContent}>
        <SliderWrapper
          className={styles['document-cards__slider']}
          options={{ infinite: data?.tariffs?.length > 2 }}
          arrows
        >
          {item?.items?.map(renderCardItem)}
        </SliderWrapper>
      </TabContentItem>
    );
  };

  return (
    <section
      className={classNames(styles['document-cards'], className)}
      itemScope
      itemType='https://schema.org/Information'
    >
      {data?.title && (
        <SectionTitle
          className={classNames(
            'wrapper',
            styles['document-cards__title'],
            'title--large',
          )}
          icon={data?.icon}
        >
          {data.title}
        </SectionTitle>
      )}
      {data?.tabs && (
        <Tabs active={activeTab}>
          <TabPanel className={classNames(['wrapper', styles.tabPanel])}>
            {data?.tabs.map(renderTab)}
          </TabPanel>
          <TabContent>{data?.tabs.map(renderContent)}</TabContent>
        </Tabs>
      )}
    </section>
  );
};

export default CardBlock;
